"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var Link =
/** @class */
function () {
  function Link() {}

  Link.prototype.LinkType = function () {
    return [{
      slug: 'instagram',
      name: 'Instagram',
      description: null,
      isInstagram: true,
      isLinkedIn: false,
      isTwitter: false,
      isFacebook: false,
      isSnapchat: false,
      isWeb: false
    }, {
      slug: 'linkedin',
      name: 'LinkedIn',
      description: null,
      isInstagram: false,
      isLinkedIn: true,
      isTwitter: false,
      isFacebook: false,
      isSnapchat: false,
      isWeb: false
    }, {
      slug: 'twitter',
      name: 'Twitter',
      description: null,
      isInstagram: false,
      isLinkedIn: false,
      isTwitter: true,
      isFacebook: false,
      isSnapchat: false,
      isWeb: false
    }, {
      slug: 'facebook',
      name: 'Facebook',
      description: null,
      isInstagram: false,
      isLinkedIn: false,
      isTwitter: false,
      isFacebook: true,
      isSnapchat: false,
      isWeb: false
    }, {
      slug: 'snapchat',
      name: 'Snapchat',
      description: null,
      isInstagram: false,
      isLinkedIn: false,
      isTwitter: false,
      isFacebook: false,
      isSnapchat: true,
      isWeb: false
    }, {
      slug: 'web',
      name: 'Web',
      description: null,
      isInstagram: false,
      isLinkedIn: false,
      isTwitter: false,
      isFacebook: false,
      isSnapchat: false,
      isWeb: true
    }];
  };

  return Link;
}();

exports.Link = Link;